<!-- https://www.npmjs.com/package/angular-svg-icon -->
<svg-icon
  [applyClass]="true"
  *ngIf="iconName"
  [ngStyle]="{ width: iconSize + 'px', height: iconSize + 'px' }"
  [src]="iconPath"
  [svgClass]="svgClass"
  [svgStyle]="svgStyle"
  [viewBox]="'auto'"
  class="{{ class }}"
  [attr.aria-label]="'Svg icon ' + iconName">
</svg-icon>
